import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgScalableFileService = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-scalable-file-service';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M3.24 12v8.76h17.52V5.24h-9.461l-.999-1-.999-1H3.24zM9.7 5.76l.999 1h8.541V8.8l-4.848.01-4.849.01-1.192 2.08c-.748 1.306-1.186 2.11-1.177 2.16.008.044.546 1.007 1.195 2.14l1.18 2.06 4.846.01 4.845.01v1.96H4.76V4.76h3.941zm4.647 5.897c.474.829.767 1.381.752 1.419-.013.034-.366.661-.784 1.393l-.761 1.331h-3.108l-.761-1.331a69 69 0 0 1-.784-1.393c-.021-.053.476-.957 1.386-2.526l.157-.271 1.563.011 1.564.01zm4.893 1.383v2.76h-1.964c-1.85 0-1.963-.004-1.938-.07a63 63 0 0 1 .764-1.359c.406-.709.738-1.31.738-1.336 0-.025-.342-.644-.76-1.375a49 49 0 0 1-.76-1.355c0-.014.882-.025 1.96-.025h1.96zm-7.705-1.159c-.28.11-.589.425-.694.705A1.246 1.246 0 0 0 12 14.28c.342 0 .629-.12.874-.366a1.24 1.24 0 0 0-.345-2c-.264-.13-.712-.144-.994-.033m.632.985c.152.138.045.414-.16.414a.243.243 0 0 1-.181-.407c.083-.091.244-.094.341-.007"
    })
  }));
});
export default SvgScalableFileService;